// extracted by css-extract-rspack-plugin
export default {"container":"RxwbfIeuYPQDkeRv__container___","tagPill":"VlTyp3kaRv872wbj__tagPill___"};